import commonMixin from '@/mixins/templates/common';

export default {
  mixins : [commonMixin],
  props  : {
    isOpen: {
      type    : Boolean,
      default : false
    },
    questions: {
      type    : String,
      default : ''
    }
  }
};
